export class UserRole {
    constructor( public id: string, public name: string, public permissions: string[]){

    }
}

export class User {
    _id: string;
    password?: string;
    firstName: string;    
    lastName: string;
    email: string;
    phone?: string;
    token?: string;
    expireDate?: Date;
    role?: string;
    permissions?: string[]
    loginFailCnt?: number;

    updatedAt?: number
    
    static getUserFullName(u:User) { u.firstName + ' ' + u.lastName }
}
